import { Injectable } from '@angular/core';
import { AppConfigModel, CascadeDeleteRule } from './app-config.model';
import { firstValueFrom, tap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Const } from '../../../../core/helpers/Const';
import { NavigationService } from '../navigation/navigation.service';
import { ServiceModule } from '../../../service.module';
import {Utils} from "../../../../core/helpers/Utils";
import {UserInfoModel} from "./user-info.model";

@Injectable({ providedIn: 'root' })
export class AppConfigService {
    private readonly APP_INFO_URL = '/api/appConfig';
  	private _userInfo: UserInfoModel;
    private _appInfo: AppConfigModel;
    private _cascadeDeleteRules: CascadeDeleteRule[];

    constructor(private readonly _httpClient: HttpClient, private readonly _navigationService: NavigationService) {}

	  async load(): Promise<AppConfigModel | void> {
        //A workaround to avoid getUserInfo call on login page which may cause issues in certain scenarios
        if (window.location.href.includes('#/login')) {
            return Promise.resolve();
        }

        return this.getAppConfig().then((res) => {
            this._userInfo = res?.userInfo;
            Utils.setFeatureFlags(res?.featureFlags);
            this._cascadeDeleteRules = res?.cascadeDeleteRules;
            return res;
        }).catch((err) => {
            if (err.status === Const.NOT_LOGGED_IN_HTTP_CODE) {
                this._navigationService.navigateToLoginPage({
                    queryParams: { redirectUrl: window.location.pathname + decodeURIComponent(window.location.hash) },
                });
            } else {
                throw new Error('Failed to load AppInfo');
            }
        });
    }

    async getAppConfig(): Promise<AppConfigModel> {
        this._appInfo = await firstValueFrom(this._httpClient.get<AppConfigModel>(this.APP_INFO_URL));
        return this._appInfo;
    }

    getAppConfigModel(): AppConfigModel {
        return this._appInfo;
    }

    getUserInfoModel(): UserInfoModel {
        return this._userInfo;
    }

    clearUserInfo(): void {
        this._userInfo = null;
    }

    getCascadeDeleteRules(): CascadeDeleteRule[] {
        return this._cascadeDeleteRules ?? [];
    }

    public getLandscape() {
        const domain = window.location.hostname || "";

        if (domain.includes("canary")) {
            return "Canary";
        }
        if (domain.includes("global")) {
            return "Global";
        }
        return "Staging";
    }
}
